import LegalPageShell from "@/components/LegalPageShell";

const SECTIONS = [
  {
    number: 1,
    title: "What Are Cookies",
    paragraphs: [
      "Cookies are small text files stored on your device when you visit a website or use a web application. They help the platform remember your session and preferences.",
    ],
  },
  {
    number: 2,
    title: "Cookies We Use",
    paragraphs: ["RootLyst uses only essential cookies required to operate the platform:"],
    bullets: [
      "Session cookies — keep you securely logged in while you use the platform",
      "Authentication cookies — verify your identity and role (Super Admin, Doctor, or Receptionist)",
      "Security cookies — help protect against unauthorized access",
    ],
  },
  {
    number: 3,
    title: "No Advertising or Tracking Cookies",
    paragraphs: ["RootLyst does not use third-party advertising or cross-site tracking cookies. Cookies are used strictly to provide secure login and maintain your session."],
  },
  {
    number: 4,
    title: "Managing Cookies",
    paragraphs: ["Most browsers allow you to control or disable cookies through their settings. Please note that disabling essential cookies may prevent you from logging in or using core platform features."],
  },
  {
    number: 5,
    title: "Changes to This Policy",
    paragraphs: ["We may update this Cookie Policy periodically. The latest version will always be available on our website."],
  },
  {
    number: 6,
    title: "Contact Us",
    paragraphs: ["For cookie-related questions, please contact:", "RootLyst Support", "Email: contact@rootlyst.com"],
  },
];

export default function CookiePolicyPage() {
  return (
    <LegalPageShell
      testId="cookie-policy-page"
      title="Cookie Policy"
      effectiveDate="18/07/2026"
      lastUpdated="18/07/2026"
      intro="This Cookie Policy explains how RootLyst, an AI-powered clinic management platform, uses cookies to provide a secure and reliable experience."
      sections={SECTIONS}
    />
  );
}
